import pathPrefix from '../../../../nuxt-language-negotiation/dist/runtime/server/negotiator/pathPrefix.js'
import query from '../../../../nuxt-language-negotiation/dist/runtime/server/negotiator/query.js'
import acceptLanguage from '../../../../nuxt-language-negotiation/dist/runtime/server/negotiator/acceptLanguage.js'
const serverOptions = {}

export const negotiators = [
  pathPrefix({}),
  query({"keys":["language","langcode"]}),
  acceptLanguage({})
]

export { serverOptions }